module.exports = __webpack_public_path__ + "assets/media/morning.798132b3.mp3";